import React from 'react';

import starGrey from '../../../public/images/icons/stay_grey_filled.svg';
import starOutlineImg from '../../../public/images/icons/star_grey_outline.svg';
import blueFullStar from '../../../public/images/blue-star.svg';
import blueOutline from '../../../public/images/blue-star-outline.svg';

import styles from './StarRating.module.scss';

const { 'star-rating': starRatingClass } = styles;

const StarRating = ({ rating, blueStar = false }) => {
  const starAmt = Math.floor(rating * 5);
  const fillStar = blueStar ? blueFullStar : starGrey;
  const starOutline = blueStar ? blueOutline : starOutlineImg;
  const starImg = starIndex => (starIndex < starAmt ? fillStar : starOutline);
  const starDescription = starIndex => (starIndex < starAmt ? 'filled' : 'unfilled');

  return (
    <div className={`${starRatingClass} ${blueStar ? 'blue' : ''}`}>
      <img src={starImg(0)} alt={`${starDescription(0)} star`} />
      <img src={starImg(1)} alt={`${starDescription(1)} star`} />
      <img src={starImg(2)} alt={`${starDescription(2)} star`} />
      <img src={starImg(3)} alt={`${starDescription(3)} star`} />
      <img src={starImg(4)} alt={`${starDescription(4)} star`} />
    </div>
  );
};

export default StarRating;
